/**
 * The key of a `source` text message (ADR-141's amendment of 2026-11-01, decision 7; PROTOCOL.md 6.103.0): the source's kind,
 * a colon and the placed prop's authored id, as `fire:camp-1`. Its field table is in `text.ts`, which `encodeText` and
 * `parseTextFrame` read.
 */

/**
 * The longest `source` key on the wire.
 */
export const MAX_SOURCE_KEY_CHARS = 128;

/**
 * Whether a source key can be sent as a `source` message: at least 3 and at most `MAX_SOURCE_KEY_CHARS` characters in the
 * `SOURCE_KEY_PATTERN` form. A key the compile accepted (a prop id with a space, a very long id, a hyphenated kind) may not be.
 *
 * @param key The family-qualified key.
 * @returns True when the wire carries it.
 */
export function sourceKeyFits(key: string): boolean {
  return key.length >= 3 && key.length <= MAX_SOURCE_KEY_CHARS && SOURCE_KEY_PATTERN.test(key);
}

/**
 * A `source` key as the wire carries it: a lower-case kind of letters and digits, a colon and an id with no whitespace.
 */
export const SOURCE_KEY_PATTERN = /^[a-z][a-z0-9]*:\S+$/;
